import { Button } from "@chakra-ui/react";

export const SelectRegionButton = ({
  region = "",
  handleClick = () => {},
}: {
  region: string;
  handleClick: () => void;
}) => {
  return (
    <Button
      size="md"
      margin={"0.5rem 0.3rem"}
      onClick={() => {
        handleClick();
      }}
    >
      {region}
    </Button>
  );
};
